import { tv } from '@joyful/utils'
import type { VariantProps } from '@joyful/utils'
import { Popover as PopoverPrimitive } from 'radix-ui'
import * as React from 'react'

export type PopoverProps = React.ComponentProps<typeof PopoverPrimitive.Root>

export const Popover = PopoverPrimitive.Root

export const PopoverAnchor = PopoverPrimitive.Anchor

export const PopoverTrigger = PopoverPrimitive.Trigger

const PopoverPortal = PopoverPrimitive.Portal

export const PopoverClose = PopoverPrimitive.Close

export const PopoverArrow = PopoverPrimitive.Arrow

export const popoverContentVariants = tv({
  base: 'pointer-events-auto z-40 min-w-72 max-w-(--radix-popover-content-available-width) animate-in fade-in-0 duration-50 rounded-md border border-tremor-border bg-tremor-background p-4 text-tremor-content-strong shadow-md outline-hidden',

  variants: {
    animation: {
      none: 'animate-none',
    },
    overflow: {
      hidden: 'overflow-hidden',
    },
    padding: {
      compact: 'p-3',
      none: 'p-0',
      xs: 'p-1',
    },
    size: {
      auto: 'w-auto min-w-0',
      flush: 'w-(--radix-popover-trigger-width) min-w-0 p-0',
      lg: 'w-lg',
      md: 'w-96',
      sm: 'w-80',
    },
    variant: {
      plain: 'border-0 bg-transparent p-0 shadow-none min-w-0',
    },
  },
})

export type PopoverContentProps = Omit<
  React.ComponentProps<typeof PopoverPrimitive.Content>,
  'className'
> &
  VariantProps<typeof popoverContentVariants>

function PopoverUnportaledContent({
  align = 'center',
  animation,
  overflow,
  padding,
  sideOffset = 4,
  size,
  variant,
  ...props
}: PopoverContentProps) {
  return (
    <PopoverPrimitive.Content
      align={align}
      sideOffset={sideOffset}
      className={popoverContentVariants({
        animation,
        overflow,
        padding,
        size,
        variant,
      })}
      {...props}
    />
  )
}

export function PopoverContent(props: PopoverContentProps) {
  return (
    <PopoverPortal>
      <PopoverUnportaledContent {...props} />
    </PopoverPortal>
  )
}
